import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { custom_auth, externalLoginUrl, noAuthAccess, redirectUrl, withAuth } from "../../context";
import { useApoAuth } from "..";

const external_website_url = import.meta.env.VITE_APP_EXT_WEBSITE_URL;

export const publicPaths = ["/register"];

export const useAuthentication = ({
  guestProfileLoading,
  userIsElligibleToAccess,
}: {
  guestProfileLoading: boolean;
  userIsElligibleToAccess: boolean;
}) => {
  const { user, isLoading: authIsLoading, loginWithRedirect, getAccessTokenSilently } = useAuth0();

  const { isAuthenticated } = useApoAuth();

  const currentPagePath = window.location.pathname;

  // If custom auth and without noAuthAccess redirect to external url
  useEffect(() => {
    if (!withAuth || noAuthAccess) {
      return;
    }

    if (publicPaths.includes(currentPagePath)) {
      return;
    }

    if (custom_auth) {
      if (!isAuthenticated && !guestProfileLoading) {
        if (window.location.href.includes("/auth")) {
          return;
        }

        window.location.href = external_website_url;
      }
      return;
    }
  }, [guestProfileLoading]);

  // If auth0 auth and without noAuthAccess redirect to external url
  useEffect(() => {
    if (!withAuth || noAuthAccess) return;
    if (custom_auth) return;
    if (publicPaths.includes(currentPagePath)) return;

    if (!authIsLoading) {
      if (import.meta.env.VITE_APP_EXTERNAL_AUTH === "true") {
        getAccessTokenSilently()
          .then(() => {
            return;
          })
          .catch(() => {
            loginWithRedirect({ redirect_uri: redirectUrl });
          });
      } else {
        if (!user) {
          const targetUrl = window.location.pathname;
          window.localStorage.setItem("targetUrl", targetUrl);
          const targetUrlSearch = window.location.search;
          if (targetUrlSearch) window.localStorage.setItem("targetUrlSearch", targetUrlSearch);
          loginWithRedirect();
        }
      }
    }
  }, [authIsLoading]);

  // Check user elligibility.
  useEffect(() => {
    if (!withAuth || noAuthAccess) return;
    if (custom_auth) return;
    if (authIsLoading || guestProfileLoading) return;

    if (!userIsElligibleToAccess) window.location.href = externalLoginUrl;
  }, [guestProfileLoading, authIsLoading, userIsElligibleToAccess]);
};
